import { ImageButton } from '../../components/button/image.button';
import { MaterialIcon } from '../../components/icon/icons';
import { Spinner } from '../../components/spinner/spinner';
import { addStyles, DefaultTheme, rgba } from '../../components/theme';
import { ColorPaletteOrange } from '../../components/theme.palette';
import { T } from '../../i18n';
import { m } from '../../mithril';
import { IkePageName } from '../../page/page';

const CSS = {
	container: 'c-TopologicalEditorToolbar',
	title: 'c-TopologicalEditorToolbarTitle',
	buttons: 'c-TopologicalEditorToolbarButtons',
	save: 'c-ButtonSaveAll',
};

const Style = {
	[CSS.container]: {
		padding: DefaultTheme.space(2),
		backgroundColor: rgba(ColorPaletteOrange.C100),
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		fontSize: '120%',
		minHeight: DefaultTheme.space(10),
		overflow: 'hidden',
	},
	[CSS.save]: {
		color: DefaultTheme.color.accent,
	},
	[CSS.title]: {
		overflow: 'hidden',
		'white-space': 'nowrap',
		'text-overflow': 'ellipsis',
	},
	[CSS.buttons]: {
		display: 'flex',
	},
};

addStyles(Style);

interface ITopologicalEditorToolbarSaveButton {
	disabled: boolean;
	onClick?: (event?: MouseEvent) => void;
	isSaving?: boolean;
}

export interface ITopologicalEditorToolbarOptions {
	title: string;
	selectedCollectionData?: {
		onClick: (event?: MouseEvent) => void;
	};
	saveButton?: ITopologicalEditorToolbarSaveButton;
}

export const TopologicalEditorToolbar = {
	saveButton(button: ITopologicalEditorToolbarSaveButton) {
		if (button.isSaving) {
			return Spinner.view();
		}
		return ImageButton.view(MaterialIcon.DONE_ALL, {
			className: CSS.save,
			title: T.TOPO_SAVE_JOB,
			disabled: button.disabled,
			onclick: button.onClick,
		});
	},

	returnButton(onClick: (event?: MouseEvent) => void) {
		return ImageButton.view(MaterialIcon.PHOTO_MEASURE, {
			title: T.LINK_PHOTOMEASURE,
			href: IkePageName.collectionMeasure,
			flip: true,
			disabled: false,
			onclick: onClick,
		});
	},

	view(opts: ITopologicalEditorToolbarOptions) {
		return m(
			'header',
			{
				className: CSS.container,
			},
			[
				m('div', { className: CSS.title, title: opts.title }, opts.title),
				m('div', { className: CSS.buttons }, [
					opts.selectedCollectionData ? this.returnButton(opts.selectedCollectionData.onClick) : null,
					this.saveButton(opts.saveButton),
				]),
			]
		);
	},
};
